import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { style, classes } from './VolumeBars.st.css';
var VolumeBars = function (props) {
    var volumeBars = [];
    var barsCount = props.barsCount || 0;
    var ariaNow = Math.round(props.context.volume * 100);
    var ariaLabel = ariaNow + "% volume" + (props.context.muted ? ', muted' : '');
    var _loop_1 = function (i) {
        volumeBars.push(React.createElement("li", { className: classes.barItemContainer, "data-hook": props.dataHook, "data-index": i, key: i, onClick: function () {
                props.context.setVolume((i + 1) / barsCount);
            } }, i / barsCount < props.context.volume
            ? props.iconBarOn
            : props.iconBarOff));
    };
    for (var i = 0; i < barsCount; i++) {
        _loop_1(i);
    }
    return (React.createElement("ul", { className: props.className, tabIndex: 0, role: "slider", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": ariaNow, "aria-valuetext": ariaLabel }, volumeBars));
};
VolumeBars.displayName = 'VolumeBars';
VolumeBars.defaultProps = {
    className: classes.container,
    dataHook: '',
    barsCount: 5,
    iconBarOn: React.createElement("div", { className: style(classes.bar, { on: true }) }),
    iconBarOff: React.createElement("div", { className: style(classes.bar, { on: false }) }),
};
export default withPlaybackContext(VolumeBars);
//# sourceMappingURL=VolumeBars.js.map